import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import ButtonComponent from "../UI/ButtonComponent/ButtonComponent";
import ModalComponent from "../UI/Modal/Modal";
import UploadComponent from "../UI/Upload/UploadComponent";
import { Switch } from "antd";
import axiosInstance from "../../api/utils/axiosInstance";
import { AuditOutlined } from "@ant-design/icons";

const DEFAULT_ERROR_MSG = "Dogodila se greška! Molimo provjerite unosene podatke i pokušajte ponovno.";

export const ApproveModal = ({ yearPlan, setYearPlan, forOrganizer }) => {

  const [isLoading, setIsLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [approvalFile, setApprovalFile] = useState([]);
  const [isApproved, setIsApproved] = useState(yearPlan.approval);

  const handleOpenModal = () => {
    setIsModalVisible(true);
  }

  const handleCloseModal = () => {
    setIsModalVisible(false);
    setApprovalFile([]);
  }

  const handleFileChange = (file, id) => {
    console.log(file);
     // provjera veličine datoteke, konverzija iz byte-ova u megabajte
     const isFileLt10MB = file.file.size / 1024 / 1024 < 10;

     if (file.file.size && !isFileLt10MB) {
       toast.error("Nije dopušteno učitavanje datoteka većih od 10MB.", {position: toast.POSITION.BOTTOM_RIGHT});
       setApprovalFile([])
       return;
     } else if (file.file.size && file.file.type !== "application/pdf") {
       toast.error("Dopušteno je učitavanje isključivo PDF formata.", {position: toast.POSITION.BOTTOM_RIGHT});
       setApprovalFile([]);
       return;
     }
 
     if (file.file.status === "removed") {
       setApprovalFile([]);
       return;
     }
     setApprovalFile([...approvalFile, file.file]);
  }

  const handleSubmitApprovalStatus = async () => {
    console.log(!!approvalFile.at(0));
    if(forOrganizer.orgType !== 2 && !!!approvalFile.at(0)){
      console.log(!!approvalFile.at(0));
      toast.error("Dokument odobrenja je obvezan ako organizator nije pripadnik mreže", {position: toast.POSITION.BOTTOM_RIGHT});
    } else {
        try{
          setIsLoading(true);
          const formData = new FormData();
        formData.append("yearPlanId", yearPlan.id);
        formData.append("approval", isApproved ? 1:0);
        formData.append("approvalDoc", approvalFile.at(0));
        const res = await axiosInstance.post("/organizer/approve", formData);
        if(res && res.status === 200){
          setYearPlan({...yearPlan, approval:isApproved})
          toast.success("Rješenje odobrenja godišnjeg plana uspješno spremljeno", {position: toast.POSITION.BOTTOM_RIGHT});
        }
      }catch(e){
        const eMsg = e.response?.data || DEFAULT_ERROR_MSG
        toast.error(eMsg, {position: toast.POSITION.BOTTOM_RIGHT});
      }finally{
        setIsLoading(false);
        handleCloseModal();
      }
    }
  }

  return(
    <>
      <ButtonComponent onClick={handleOpenModal} icon={<AuditOutlined />} size="large" >Izdaj odobrenje</ButtonComponent>
      <ModalComponent show={isModalVisible} onHide={handleCloseModal} title="Izdaj odobrenje">
        <div className="approve-edu-upload-wrapper">
          <div>
          <label>{forOrganizer.orgType !== 2 && "*"}Dokument odobrenja</label>
          <UploadComponent fileList={approvalFile} accept={".pdf"} onChange={handleFileChange} />
          </div>
          <div>
          <label>Status</label>
          <Switch checked={isApproved} checkedChildren="Odobreno" unCheckedChildren="Neodobreno" onChange={(checked) => setIsApproved(checked)} className="edu-switch-sts"/>
          </div>
        </div>
        <div className="row-action-wrapper">
            <ButtonComponent type="button" className="btn" variant="danger" block={true} onClick={handleCloseModal} disabled={isLoading}>Odustani</ButtonComponent>
            <ButtonComponent type="submit" className="btn" block={true} onClick={handleSubmitApprovalStatus} loading={isLoading}>Spremi</ButtonComponent>
        </div>
      </ModalComponent>
    </>
  );
}